'use strict';
import * as $j_app$002edata$002edocument$005ftemplates$0024package$0024$002dDocument$002dTemplate$002dName$0024 from "./app.data.document_templates$package$-Document-Template-Name$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$() {
  this.aTP = null;
  this.aU4 = null;
  this.aTS = null;
  this.aTT = false;
  this.aTW = null;
  this.aTX = false;
  this.aU2 = null;
  this.aU3 = false;
  this.aTQ = null;
  this.aTR = false;
  this.aU0 = null;
  this.aU1 = false;
  this.aTY = null;
  this.aTZ = false;
  this.aTU = null;
  this.aTV = false;
  $n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ = this;
  this.aTP = $j_app$002edata$002edocument$005ftemplates$0024package$0024$002dDocument$002dTemplate$002dName$0024.$m_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$();
  this.aU4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002edocument$005ftemplates$0024package$0024$002dDocument$002dTemplate$002dName$0024.$m_Lapp_data_document\uff3ftemplates$package$DocumentTemplateName$());
}
export { $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ as $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ };
$p = $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$;
/** @constructor */
function $h_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$() {
}
export { $h_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ as $h_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ };
$h_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$.prototype = $p;
$p.eR = (function() {
  return this.aTP;
});
$p.eO = (function() {
  return this.aU4;
});
$p.bW = (function() {
  if ((!this.aTT)) {
    this.aTS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aTT = true;
  }
  return this.aTS;
});
$p.b9 = (function() {
  if ((!this.aTX)) {
    this.aTW = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aTX = true;
  }
  return this.aTW;
});
$p.b3 = (function() {
  if ((!this.aU3)) {
    this.aU2 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aU3 = true;
  }
  return this.aU2;
});
$p.aG = (function() {
  if ((!this.aTR)) {
    this.aTQ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aTR = true;
  }
  return this.aTQ;
});
$p.az = (function() {
  if ((!this.aU1)) {
    this.aU0 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aU1 = true;
  }
  return this.aU0;
});
$p.aY = (function() {
  if ((!this.aTZ)) {
    this.aTY = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aTZ = true;
  }
  return this.aTY;
});
$p.bN2 = (function() {
  if ((!this.aTV)) {
    this.aTU = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Name";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aTV = true;
  }
  return this.aTU;
});
var $d_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$, "app.data.document_templates$package$DocumentTemplateNameForm$", ({
  GK: 1,
  N: 1
}));
export { $d_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ as $d_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ };
var $n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$;
function $m_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$() {
  if ((!$n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$)) {
    $n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ = new $c_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$();
  }
  return $n_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$;
}
export { $m_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ as $m_Lapp_data_document\uff3ftemplates$package$DocumentTemplateNameForm$ };
//# sourceMappingURL=app.data.document_templates$package$-Document-Template-Name-Form$.js.map
